module.exports = __webpack_public_path__ + "img/map7.0bbacf4d.png";